import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import moment from 'moment'
import AccordionHeaderContent from './AccordionHeaderContent'
import NotStartedStepMessage from './NotStartedStepMessage'
import IOrder from '@interfaces/IOrder'
import { getStepState } from '../utils/getStepState'

interface AccordionShipmentScheduledProps {
  stepProgress: number
  inProgressOrder: IOrder | null
}

const AccordionShipmentScheduled: React.FC<AccordionShipmentScheduledProps> = ({
  stepProgress,
  inProgressOrder
}) => {
  const stepState = getStepState(stepProgress)

  return (
    <Accordion.Item eventKey="8" className={`${stepState}-state desabled`}>
      <Accordion.Header>
        <AccordionHeaderContent
          stepState={stepState}
          progress={stepProgress}
          title="Envio da Amostra de Sêmen Agendado"
        />
      </Accordion.Header>

      <Accordion.Body>
        <div className="check-sample p-3">
          {stepProgress < 8 ? (
            <NotStartedStepMessage />
          ) : inProgressOrder?.send_scheduled_at ? (
            <>
              <p className="mb-0">
                Sua clínica agendou a retirada da sua amostra de sêmen para o dia:{' '}
                <b>{moment(inProgressOrder.send_scheduled_at).format('DD/MM/YYYY')}</b>
              </p>
              <p className="mb-0 mt-3">O prazo de entrega é de até {inProgressOrder.clinic?.delivery_time}h!</p>
              <p className="mb-0 mt-3">O envio da sua amostra de sêmen é realizados por transportadoras habilitadas em transportes de materiais biológicos.</p>
            </>
          ) : (
            <p className="mb-0">Aguardando agendamento do envio da amostra de sêmen.</p>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionShipmentScheduled
